import React, { useState, useEffect, useRef } from 'react'
import { focusElemnt, getMapDistance, incrementGmapAPiCounter, navigation1, saveRecentSearches } from '../../common/helper'
import * as iid from '../../common/bookingElementId'
let autoComplete

const loadScript = (url, callback) => {
  let script = document.createElement('script')
  script.type = 'text/javascript'

  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null
        // console.log('from here')
        callback()
      }
    }
  } else {
    script.onload = () => {
      // console.log('from there')
      callback()
    }
  }
  script.src = url
  document.getElementsByTagName('head')[0].appendChild(script)
}
function MyScriptLoaded() {
  const url = 'https://maps.googleapis.com/maps/api/js?key'
  var scripts = document.getElementsByTagName('script')
  for (var i = scripts.length; i--;) {
    if (scripts[i].src.includes(url)) return true
  }
  return false
}
function calculateDistance(origin, destination) {
  const R = 6371 // Radius of the Earth in kilometers
  const dLat = deg2rad(destination.lat() - origin.lat())
  const dLon = deg2rad(destination.lng() - origin.lng())

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(origin.lat())) * Math.cos(deg2rad(destination.lat())) * Math.sin(dLon / 2) * Math.sin(dLon / 2)

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  const distance = R * c // Distance in kilometers

  return distance.toFixed(2)
}

// Function to convert degrees to radians
function deg2rad(deg) {
  return deg * (Math.PI / 180)
}
function handleScriptLoad(updateQuery, autoCompleteRef, setAddress, isDeliver, originLatLong) {
  const options = {
    fields: ['formatted_address', 'geometry', 'name'],
    strictBounds: false,
    types: ['establishment'],
  }
  try {
    autoComplete = new window.google.maps.places.Autocomplete(autoCompleteRef.current, options)
    autoComplete.setFields(['address_components', 'formatted_address'])
    autoComplete.addListener('place_changed', () => handlePlaceSelect(updateQuery, setAddress, isDeliver, originLatLong))
  } catch (err) {
    console.log(err)
  }
}

async function handlePlaceSelect(updateQuery, setAddress, isDeliver, originLatLong) {
  const APIKEY = JSON.parse(sessionStorage.getItem('APIKEY')) || ''
  let place = autoComplete.getPlace();
  place.GMapAddress = JSON.stringify(place);
  place.isd = `+91`;

  const postalCode = place.formatted_address.match(/\d{6}/) || false;
  const cityStateRegex = /([^,]+),\s*([^,]+)\s*(\d{6})/;
  const match = place.formatted_address.match(cityStateRegex);

  place.city = match ? match?.[1].trim() : '';
  place.state = match ? match?.[2].trim() : '';
  place.pincode = postalCode ? postalCode : '';

  incrementGmapAPiCounter();

  const origin = {
    latitude: originLatLong[0],
    longitude: originLatLong[1],
  };

  const destination = {
    latitude: place.geometry.location.lat(),
    longitude: place.geometry.location.lng(),
  };

  try {
    if (originLatLong?.length) {
      const res = await getMapDistance({
        origin,
        destination,
        apiKey: APIKEY,
      });

      const distanceMeters = res?.routes?.[0]?.legs?.[0]?.distanceMeters;
      const distanceText = distanceMeters
        ? (distanceMeters / 1000).toFixed(2) + ' km'
        : calculateDistance(origin, destination) + ' km'; // fallback

      const calculateAndSetDistance = (distance) => {
        place.isDeliver = isDeliver;
        if (!isDeliver) {
          place.pickupDistance = distance;
          place.pickupFrom = originLatLong;
        } else {
          place.deliveryDistance = distance;
          place.deliveryFrom = originLatLong;
        }
      };

      calculateAndSetDistance(distanceText);

      if (place.formatted_address) {
        setAddress(place);
        saveRecentSearches(place);
      }
    } else {
      if (place.formatted_address) {
        setAddress(place);
        saveRecentSearches(place);
      }
    }
  } catch (err) {
    setAddress(place);
    saveRecentSearches(place);
    console.error("Error fetching distance:", err);
  }

  incrementGmapAPiCounter();
  updateQuery('');
}

function SearchLocationInput(props) {
  const { setAddress, isDeliver = false, originLatLong } = props
  const [query, setQuery] = useState('')
  const autoCompleteRef = useRef(null)
  const APIKEY = JSON.parse(sessionStorage.getItem('APIKEY')) || ''
  useEffect(() => {
    if (MyScriptLoaded()) {
      handleScriptLoad(setQuery, autoCompleteRef, setAddress, isDeliver, originLatLong)
    } else {
      loadScript(`https://maps.googleapis.com/maps/api/js?key=${APIKEY}&libraries=places`, () =>
        handleScriptLoad(setQuery, autoCompleteRef, setAddress, isDeliver, originLatLong)
      )
    }
  }, [])
 React.useEffect(()=>{
    focusElemnt(iid.gmapInputId)
  },[])
  return (
    <div className="input--content">
      <input
        id={iid.gmapInputId}
        className="googleAutoComplete"
        ref={autoCompleteRef}
        onChange={(event) => setQuery(event.target.value)}
        placeholder="Search for area, Street name"
        value={query}
        onKeyDown={(e)=>navigation1(e,'gpslocation','saveadrressbtn')}
      />
    </div>
  )
}

export default React.memo(SearchLocationInput)
